export interface CreditCardInfo {
	firstName: string;
	lastName: string;
	cardExpirationMonth: string;
	cardExpirationYear: string;
	cardType: string;
	transientToken: string;
}

export const defaultCreditCardInfo: CreditCardInfo = {
	firstName: '',
	lastName: '',
	cardExpirationMonth: '',
	cardExpirationYear: '',
	cardType: '',
	transientToken: '',
};
